import React from 'react';
import { useLocation, Outlet  } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Navigate } from "react-router-dom";

const PublicLayout = () => {
    const location = useLocation(); // Get the current location object
    const isRegisterPage = location.pathname === '/register'; // Check if it's the login page
    const pageClass  = isRegisterPage ? 'register-page' : 'login-page'; // Set the class name
    const boxClass  = isRegisterPage ? 'register-box' : 'login-box'; // Set the class name
    const { isAuthenticated, isAdminUser } = useAuth();
    if (isAuthenticated) {
        return <Navigate to={ isAdminUser ? "/admin/dashboard" : "/dashboard" } />;
    }

    return (
        <div className={`hold-transition ${pageClass}`}>
            <div className={boxClass}>
                <div className="card card-outline card-primary">
                    <div className="card-header text-center">
                        <img src="../dist/img/logos/dark-logo-6.png" alt="Easy Rojmel" className="w-100"></img>
                    </div>
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default PublicLayout;